const cubicBezier = {
    'productiveEaseInOut': 'cubic-bezier(0.2, 0.2, 0.38, 0.9)',
    'productiveEaseIn': 'cubic-bezier(0.2, 0, 1, 0.9)',
    'productiveEaseOut': 'cubic-bezier(0, 0, 0.38, 0.9)',

    'expressiveEaseInOut': 'cubic-bezier(0.4, 0.14, 0.3, 1)',
    'expressiveEaseIn': 'cubic-bezier(0.4, 0.14, 1, 1)',
    'expressiveEaseOut': 'cubic-bezier(0, 0, 0.3, 1)',

    'celebratoryEaseInOut': 'cubic-bezier(0.29, 0.04, 0.23, 1)',
    'celebratoryEaseIn': 'cubic-bezier(0.39, .06, 1, 1)',
    'celebratoryEaseOut': 'cubic-bezier(0, 0, 0.3, 1)',
};

export default cubicBezier;